import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { CouponCodeClientService } from '../../../services/index';
import { AddEditCouponCodeClientComponent } from './addEditCouponCodeClient.component';

@Component({
    selector: 'coupon-code-client',
    templateUrl: './couponCodeClient.component.html',
})
export class CouponCodeClientComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    recordList: any[] = [];
    columns = [];

    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    scrollTimeout: any;
    suppressPaging: boolean = false;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'ccc.created_date',
        orderDir: 'desc'
    };

    filterData = { search_name: '' };

    bsModalRef: BsModalRef;

    constructor(
        private couponCodeClientService: CouponCodeClientService,
        private modalService: BsModalService
    ) {}

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo',         prop: 'sno',         width: 60,  minWidth: 60,  maxWidth: 60,  sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate },
            { name: 'Mobile',      prop: 'mobile',      width: 140, minWidth: 140, maxWidth: 160 },
            { name: 'Client ID',   prop: 'client_no',   width: 120, minWidth: 120, maxWidth: 140 },
            { name: 'Client Name', prop: 'client_name', width: 180, minWidth: 150, maxWidth: 260 },
            { name: 'Coupon Code', prop: 'coupon_code', width: 150, minWidth: 120, maxWidth: 200 },
            { name: 'Action',      prop: 'id',          width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-center', cellTemplate: this.actionTemplate },
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.loadList();
        }
    }

    onScroll() {
        this.suppressPaging = true;
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.loadList();
    }

    onOpenedFilter(): void {
        setTimeout(() => { $('#filterSearch').focus(); }, 100);
    }

    applyFilter() {
        this.filterPanel.close();
        this.page.offset = 0;
        this.loadList();
    }

    clearFilter() {
        this.filterData = { search_name: '' };
        this.page.offset = 0;
        this.loadList();
    }

    // ── Add / Edit / View ───────────────────────────────────────────────────────

    onAddEditRecord(mode: string, row: any): void {
        const that = this;
        this.bsModalRef = this.modalService.show(AddEditCouponCodeClientComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg'
        });
        this.bsModalRef.content.title      = mode + ' Coupon Code Received Client';
        this.bsModalRef.content.mode       = mode;
        this.bsModalRef.content.recordData = Object.assign({}, row);
        this.bsModalRef.content.recordLoadEvent.subscribe(() => {
            that.loadList();
        });
    }

    // ── Delete ──────────────────────────────────────────────────────────────────

    onDeleteRecord(row: any): void {
        const that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'This action cannot be undone!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.couponCodeClientService.deleteRecord(row.id).then((res: any) => {
                if (res.success) {
                    swal('Deleted', res.message, 'success');
                    that.loadList();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        }, function (dismiss) { });
    }

    // ── List ────────────────────────────────────────────────────────────────────

    loadList() {
        const params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        params['search_name'] = this.filterData.search_name;
        this.isLoadMask = this.couponCodeClientService.getCouponCodeClientList(params).then((res: any) => {
            this.loadingIndicator = false;
            if (res && res.data) {
                this.recordList = res.data;
                this.page.count = res.totCnt;
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/couponCodeClient/couponCodeClient.component.ts